// This is all you.
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

import TrustpilotSlider from './components/trustpilot-slider';
import TabGroup from './components/tab-group';
import HubSpotForm from './components/newsletter-submit';
import BusinessNameSearchForm from './components/business-name-search-form';
import BusinessNameInformationForm from './components/business-name-information';
import BusinessNameGenerator from './components/businessNameGenerator-submit';
import LLCCostsByState from './components/llc-costs-by-state';
import ContactForm from './components/contact-form';
import typingText from './components/typingText';
import TextStyling from './components/text';
import Dropdown from './components/dropdown';
import Navigation from './navigation-utils';
import DisplayOptions from './components/display-options';
import getPricesByCityAndType from './components/getPricesByCityAndType';
import getFullPriceAndFiling from './components/getFullPriceAndFiling';
import RatingStars from './components/rating-stars';
import CorporateFilingTimes from './components/corporate-filing-times';
import TabsBehavior from './components/tabs';
import VideoPlayer from './components/video-player';
import ArticleLikes from './components/article-likes';
import ArticleCategories from './components/article-categories';
import DowloadGuideTypeAndEntitiesForm from './components/dowload-guide-types-and-entities';
import Accordion from './components/accordion';
import CalculateBenefits from './components/calculate-immediate-benefits-form';
import Carrusel from './components/carrusel';
import AssignRandomId from './components/assign-random-id';
import AlignmentOptions from './components/alignment-options';
import LetsConnectPartnerForm from './components/lets-connect-partner-form';
import AskForm from './components/ask-form';
import StatesUtils from './components/states-utils';
import Stars from './components/stars';
import StartGuideTemplates from './components/start-guide-templates';
import GuidesTabs from './components/guides-tabs';
import EditThisPage from './components/edit-this-page';
import StatesMap from './components/states-map';
import VirtualAddress from './components/virtual-address';
import Carrousel from './components/carrousel';
import ScrollToSection from './components/scrollToSection';
import TaxCalculatorForm from './components/tax-calculator-form';
import GetTableStateVariant from './components/get-table-state-variant';
import ContractTemplatesLibrary from './components/contract-templates-library';

typingText.init(Alpine);
HubSpotForm.init(Alpine);
TrustpilotSlider.init(Alpine);
TabGroup.init(Alpine);
BusinessNameInformationForm.init(Alpine);
BusinessNameSearchForm.init(Alpine);
BusinessNameGenerator.init(Alpine);
LLCCostsByState.init(Alpine);
ContactForm.init(Alpine);
TextStyling.init(Alpine);
Dropdown.init(Alpine);
Navigation.init(Alpine);
DisplayOptions.init(Alpine);
getPricesByCityAndType.init(Alpine);
getFullPriceAndFiling.init(Alpine);
RatingStars.init(Alpine);
CorporateFilingTimes.init(Alpine);
TabsBehavior.init(Alpine);
VideoPlayer.init(Alpine);
ArticleLikes.init(Alpine);
ArticleCategories.init(Alpine);
DowloadGuideTypeAndEntitiesForm.init(Alpine);
Accordion.init(Alpine);
CalculateBenefits.init(Alpine);
Carrusel.init(Alpine);
AssignRandomId.init(Alpine);
AlignmentOptions.init(Alpine);
LetsConnectPartnerForm.init(Alpine);
AskForm.init(Alpine);
StatesUtils.init(Alpine);
Stars.init(Alpine);
StartGuideTemplates.init(Alpine);
GuidesTabs.init(Alpine);
EditThisPage.init(Alpine);
StatesMap.init(Alpine);
VirtualAddress.init(Alpine);
Carrousel.init(Alpine);
ScrollToSection.init(Alpine);
TaxCalculatorForm.init(Alpine);
GetTableStateVariant.init(Alpine);
ContractTemplatesLibrary.init(Alpine);

Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();
